export default __webpack_public_path__ + "static/media/SinEmbargo.0a2c216e.jpg";